import React from 'react';
import { Spin } from 'antd';
import '../assets/styles/RedirectLoader.css';

const RedirectLoader = () => {
  return (
    <div className="redirect-loader">
      <Spin size="large" />
      <p className="redirect-message">Redirigiendo...</p>
    </div>
  );
};

export default RedirectLoader;
